export default class {
  constructor({ canceller }) {
    this.requests = new Set();
    this.canceller = canceller;
  }

  add(request) {
    this.requests.add(request);
  }

  remove(request) {
    this.requests.delete(request);
  }

  cancelAll() {
    this.requests.forEach(request => {
      this.canceller(request);
    });
  }

  clearAll() {
    this.requests.clear();
  }

  flush() {
    this.cancelAll();
    this.clearAll();
  }
}
